export const serverExpression = {
  regexp : new RegExp(/^[a-zA-Z]+$/),
  numberregexp : new RegExp(/^\d*$/),
  decimalregex : new RegExp(/^\d+((.)|(.\d{0,15})?)$/),
  dotnadno : new RegExp(/^[0-9.]*$/)
  };